var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.7 21.7L36.5 5.9l3.9 3.9-15.8 15.9-5.6 1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M23.6 18.8c-.8-.4-1.7-.7-2.7-.7h-7.2c-3.1 0-5.6 2.5-5.6 5.7v7.3c0 3.1 2.6 5.6 5.6 5.6h7.2c3.1 0 5.7-2.5 5.7-5.6v-7.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M3.8 29.4c-1-1-1.7-2.4-1.7-4v-7.2c0-3.1 2.5-5.7 5.7-5.7H15c1.2 0 2.2.3 3.1.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14.4,
    cy: 30.7,
    r: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkedit);
export default __webpack_public_path__ + "static/media/bulkedit.c6d2fc8f9c7a21d6b156f61da9e92b91.svg";
export { ForwardRef as ReactComponent };